($ => {

	'use strict';

	function init() {

		initBlockTabs()
		
	}

	function initBlockTabs(){

		let blockTabs = document.querySelectorAll('.blockTabs')
		for (let i = 0; i < blockTabs.length; i++) {
			let tabs = blockTabs[i].querySelectorAll('.blockTabs__tab')
			for (let i = 0; i < tabs.length; i++) {
				tabs[i].addEventListener('click', function(event) {
					
					let parent = this.parentNode
					let index = Array.prototype.indexOf.call(parent.children, this)
					let tables = parent.parentNode.querySelectorAll('.blockTabs__table')
					for (let i = 0; i < tabs.length; i++) {
						tabs[i].classList.remove("active");
					}
					for (let i = 0; i < tables.length; i++) {
						tables[i].classList.remove("active");
					}

					this.classList.add("active");
					tables.item(index).classList.add("active")
					
				})
			}
		}

	}

	$(document).ready(() => {
		init();
	});

})(jQuery);
